const config = {
    appName: "VISA24",
    isAdmission24: false
}

export default config;